import { useEffect } from 'react';

import { useGetPaymentMethodsQuery } from '@/modules/payment-methods';
import { showError } from '@/shared';

export const useGetPaymentMethods = () => {
  const { data, isLoading, isError } = useGetPaymentMethodsQuery();

  useEffect(() => {
    if (isError) {
      showError({ message: 'Произошла ошибка!' });
    }
  }, [isError]);

  return {
    data,
    isLoading,
  };
};
